/* eslint-disable indent */

import React, { ErrorInfo, ReactNode } from 'react';
import { appInsightsReactPlugin } from '../utils/applicationInsights';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

interface IProps {
    children: ReactNode
    fallback: ReactNode
}

class ErrorBoundary extends React.Component<IProps> {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        appInsightsReactPlugin.trackException(
            {
                error: error,
                exception: error,
                severityLevel: SeverityLevel.Error,
                properties: info
            },
            {
                epimedErrorUrl: window.location.href
            }
        );

        console.log({ error, info });
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;